import { render, staticRenderFns } from "./FormulaBanner.vue?vue&type=template&id=b6c22e76&scoped=true&"
import script from "./FormulaBanner.vue?vue&type=script&lang=js&"
export * from "./FormulaBanner.vue?vue&type=script&lang=js&"
import style0 from "./FormulaBanner.vue?vue&type=style&index=0&id=b6c22e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c22e76",
  null
  
)

export default component.exports